import { useTranslation } from 'react-i18next';
import { LockKeyIcon } from '@phosphor-icons/react';

interface SubscriptionPaywallProps {
  companyName?: string;
}

export const SubscriptionPaywall = ({ companyName }: SubscriptionPaywallProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center p-8 min-h-[60vh]">
      <div className="bg-white rounded-lg shadow-lg p-10 w-full max-w-2xl flex flex-col items-center text-center gap-6">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 text-primary">
          <LockKeyIcon size={32} weight="bold" />
        </div>

        <div className="flex flex-col gap-2">
          <h2 className="text-2xl font-display text-primary">{t('subscription.paywall.title')}</h2>
          {companyName ? (
            <p className="text-sm text-gray-500">
              {t('subscription.paywall.company_label', { companyName })}
            </p>
          ) : null}
        </div>

        <p className="text-base text-gray-700 leading-relaxed">
          {t('subscription.paywall.description')}
        </p>

        <div className="bg-gray-50 rounded-lg p-4 w-full text-left">
          <p className="text-sm text-gray-600 leading-relaxed">
            {t('subscription.paywall.contact_instructions')}
          </p>
        </div>
      </div>
    </div>
  );
};
